import { Journeys } from "types/Journeys"
import { JourneyData, Step } from "./useCreateCarrotPlan"
import { useRecommendationsDiff } from "./useRecommendationsDiff"
import { useReportRecommendationsAdminChanges } from "./useReportRecommendationsAdminChanges"
import { useRecommendationsEnabledJourneys } from "./useRecommendationsEnabledForJourney"
import { useGetBenefitEnabledJourneysForEmployee } from "./useGetJourneys"

export function useTrackRecommendationChanges(employeeId: number) {
  const { data: benefitEnabledJourneyData } = useGetBenefitEnabledJourneysForEmployee(employeeId)
  const enabledJourneys = useRecommendationsEnabledJourneys()
  const { getRecommendationsDiff } = useRecommendationsDiff(employeeId)
  const reportMutation = useReportRecommendationsAdminChanges()

  return function trackRecommendationChanges(planSteps: Step[], journeyData: JourneyData, carrotPlanId: number) {
    const journeyEnumName = (benefitEnabledJourneyData as Journeys | undefined)?.find(
      (j) => j.journeyId === journeyData.primaryJourneyId
    )?.journeyEnumName
    if (!journeyEnumName || !enabledJourneys.includes(journeyEnumName)) return

    const diff = getRecommendationsDiff(planSteps, journeyData)
    // Report on every resolvable outcome, including "unchanged", so the alert always fires
    // when recommendations were shown. "no-recommendations" has nothing to report.
    if (diff.status === "reordered" || diff.status === "modified" || diff.status === "unchanged") {
      reportMutation.mutate({
        employeeId,
        carrotPlanId,
        journeyId: journeyData.primaryJourneyId,
        journeyStageId: journeyData.primaryJourneyStageId,
        diff
      })
    }
  }
}
